import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Card from '@/modules/common/components/Card';
import Spinner from '@/modules/common/components/Spinner';
import ChipLink from '@/modules/common/components/ChipLink';
import ErrorFetch from '@/modules/common/components/ErrorFetch';
import { withFetch } from '~/hocs/fetch';

let abortController;

const Information = (props) => {
    const name = props.match.params.name;

    const [loading, setLoading] = useState(true);
    const [offer, setOffer] = useState(null);

    const fetch = () => {
        abortController = new AbortController();
        setLoading(true);
        props.fetch.get(`/api/offers/${name}/`, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    setOffer(data);
                }
                setLoading(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setLoading(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    useEffect(() => {
        fetch();
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    // noinspection JSUnresolvedVariable
    return (
        <Card>
            <CardHeader title="Детальная информация"/>
            <CardContent className={(loading) ? 'loading' : ''}>
                {(!loading)
                    ? <>
                        {(offer)
                            ? <>
                                <Typography>Название: {offer.offer_name}</Typography>
                                <Typography>ID: {offer.offer_id}</Typography>
                                <div id="related">
                                    {(offer.related_count.leads)
                                        ? <ChipLink label={`Лиды: ${offer.related_count.leads}`}
                                                    to={`/leads/?offer_name=${offer.offer_name}`}
                                        />
                                        : null
                                    }
                                    <ChipLink label={`Типы: ${offer.related_count.types}`}
                                              to={`/offers/${offer.offer_name}/types/`}
                                    />
                                    <ChipLink label={`Статусы: ${offer.related_count.statuses}`}
                                              to={`/offers/${offer.offer_name}/statuses/`}
                                    />
                                    <ChipLink label={`Автоматические статусы: ${offer.related_count.auto_statuses}`}
                                              to={`/offers/${offer.offer_name}/auto-statuses/`}
                                    />
                                    <ChipLink label={`Лендинги: ${offer.related_count.landings}`}
                                              to={`/offers/${offer.offer_name}/landings/`}
                                    />
                                </div>
                            </>
                            : <ErrorFetch onClick={() => fetch()}/>
                        }
                    </>
                    : <Spinner/>
                }
            </CardContent>
        </Card>
    );
};

let Component = Information;
Component = withRouter(Component);
Component = withFetch(Component);

export default Component;
